<template>
    <div class="container pb-4 mb-4">

<!-- no subscription -->
<span v-if="enabled == 0">

<div class="col-md-8 mx-auto">

  <need-subscription></need-subscription>

<span v-if="sites.length > 0">
  <div class="text-center py-2">
    <a href="#/" @click="showSites = !showSites" class="btn btn-link">
      <span v-if="showSites == false">Manage websites</span>
      <span v-else>Hide websites</span>
    </a>
  </div>

  <div class="card" v-if="showSites == true">
    <div class="card-body pb-0">

  <!-- let user delete websites -->
  <!-- Desktop -->
  <table class="datatables-basic table d-none d-md-table">
  <thead class="thead-dark">
        <tr>
          <th class="first-left pl-3" width="80%">Website</th>
          <th class="first-right pl-3" width="20%">Action</th>
        </tr>
      </thead>
  <tbody>
    <tr class="body2" v-for="(site, index) in sites" :key="index.id">
      <td class="pl-3">
        <div>{{site.name}}</div>
        </td>

      <td class="pl-3">
        <a href="#/" title="Delete site" @click="showDeleteSite(site)"><i class="fas fa-trash mr-2"></i>Delete</a>
        </td> 
    </tr>
  </tbody>
  </table>

  <!-- Mobile -->
  <table class="table d-md-none">
  <thead class="thead-dark">
        <tr>
          <th class="first-left first-right pl-3">Site</th>
        </tr>
      </thead>
  <tbody>
    <tr class="body2" v-for="(site, index) in sites" :key="index.id">
      <td class="pl-3">
        <div>{{site.name}}</div>
        <div><a href="#/" title="Delete site" @click="showDeleteSite(site)"><i class="fas fa-trash mr-2"></i>Delete</a></div>
        </td>  
    </tr>
  </tbody>
  </table>

    </div>
  </div>
</span>

</div>

</span>

<!-- has subscription -->
<div v-else>

<div class="row">
      <div class="col"><h5 class="mb-3">Websites</h5></div>
      <div v-if="sites.length > 0" class="col text-right pt-1 mb-md-0 mb-3">
        <i class="fas fa-plus-circle mr-2"></i>
        <span v-if="checking"><i class="fas fa-spinner fa-spin"></i></span>
        <a v-else href="#/" @click="checkSubscription()">Add website</a>
    </div>
</div>

<free-trial 
  v-if="!loading && days_left > 0 && subscriptions.length == 0" 
  :days_left="days_left"></free-trial>

  <div class="card">
    <div class="card-body pb-0">

      <div v-if="loading" class="text-center pt-2 pb-4"><i class="fas fa-spinner fa-spin"></i></div>

      <div v-else-if="sites.length == 0" class="text-center pb-4">
            <span v-if="checking"><i class="fas fa-spinner fa-spin"></i></span>
            <a v-else href="#/" @click="checkSubscription()" class="btn btn-success px-3">Add website</a>
      </div>

        <div v-else>

          <div class="text-center pb-3">
            <select class="date-range" v-model="filter" @change="getWebsites(true)">
                <option v-for="(status, index) in statuses" :key="index" :value="status">{{status}}</option>
            </select>
            <span v-if="loadingFilter" class="date-range-text"><i class="fas fa-spinner fa-spin"></i></span>
            <span v-else-if="rangeText" class="date-range-text">{{rangeText}}</span>
          </div>

          <!-- Desktop -->
          <table class="datatables-basic table d-none d-md-table">
          <thead class="thead-dark">
                <tr>
                  <th class="first-left pl-3" width="25%">Name</th>
                  <th class="text-center" width="15%">Tracking code</th>
                  <th class="text-center" width="40%">Visitors</th>
                  <th class="first-right pl-3" width="20%">Action</th>
                </tr>
              </thead>
          <tbody>
            <tr class="body2" v-for="(site, index) in sites" :key="index.id">
              <td class="pl-3">
                <a v-if="site.code=='Installed'" :href="`/websites/view/${site.id}`">{{site.name}}</a>
                <div v-else>{{site.name}}</div>
                </td>
              <td class="text-center">
                <span v-if="site.code=='Installed'"><i class="fas fa-check-circle credit" :title="site.code"></i></span>
                <span v-else><i class="fas fa-times-circle debit" :title="site.code"></i></span>
                </td>     
              <td class="text-center">{{site.visitors}}</td> 
              <td class="pl-3">
                <a class="blue2" v-if="site.code=='Installed'" :href="`/websites/view/${site.id}`" title="See visitors"><i class="fas fa-chart-line mr-2"></i>See visitors</a>
                <span v-else>
                <a href="#/" class="mr-4" title="Tracking code" @click="showTrackingCode(site)"><i class="fas fa-gear mr-2"></i></a>
                <a href="#/" title="Delete site" @click="showDeleteSite(site)"><i class="fas fa-trash"></i></a>
                </span>
                </td> 
            </tr>
          </tbody>
        </table>

        <!-- Mobile -->
        <table class="table d-md-none">
          <thead class="thead-dark">
                <tr>
                  <th class="first-left pl-3" width="80%">Name</th>
                  <th class="first-right pr-3" width="20%">Visitors</th>
                </tr>
              </thead>
          <tbody>
            <tr class="body2" v-for="(site, index) in sites" :key="index.id">
              <td class="pl-3">
                <span v-if="site.code=='Installed'"><i class="fas fa-check-circle credit mr-2" :title="site.code"></i></span>
                <span v-else><i class="fas fa-times-circle debit mr-2" :title="site.code"></i></span><a v-if="site.code=='Installed'" :href="`/websites/view/${site.id}`">{{site.name}}</a>
                <div v-else>{{site.name}}</div>
                <div>
                <a class="blue2" v-if="site.code=='Installed'" :href="`/websites/view/${site.id}`" title="See visitors"><i class="fas fa-chart-line mr-2"></i>See visitors</a>
                <span v-else>
                <a href="#/" class="mr-4" title="Tracking code" @click="showTrackingCode(site)"><i class="fas fa-gear"></i></a>
                <a href="#/" title="Delete site" @click="showDeleteSite(site)"><i class="fas fa-trash"></i></a>
                </span>
                </div>
                </td>  
              <td class="text-right pr-3">{{site.visitors}}</td>
            </tr>
          </tbody>
        </table>

        </div>

  <new-site ref="NewSite"></new-site>
  <tracking-code :site="selectedSite"></tracking-code>
  
  </div>
  </div>
</div>

<delete-site ref="DeleteSite" :site="selectedSite" page="websites"></delete-site>
</div>
</template> 

<script>
import { EventBus } from '../bus';

export default {
props: ['user_id','enabled','days_left','subscriptions'],
  data() {
    return {
      filter: 'Today',
      sites: [],
      selectedSite: {},
      loading: true,
      statuses: ['Today', 'Yesterday','This week','Last week','This month','Last month','This year','Last year','All time'],
      rangeText: null,
      loadingFilter: false,
      checking: false,
      showSites: false,
    };
  },

  created() {
    this.getWebsites();

    EventBus.$on('site-created', (site) => {
      // open tracking code modal
      console.log('Site created');
      console.log(site);
      this.getWebsites();
      this.showTrackingCode(site);
    });

    EventBus.$on('tracking-updated', () => {
      this.getWebsites();
    });

    EventBus.$on('site-deleted', () => {
      this.getWebsites();
    });

    Echo.channel("user_"+ this.user_id)
      .listen("SiteVisitor", (event) => {
        this.getWebsites();
      });

    Echo.channel("user_"+ this.user_id)
    .listen("TrackingStatus", (event) => {
      this.getWebsites();
    });

  },

  methods: {

    checkSubscription() {

      this.checking = true;

      axios.get('/subscriptions/check').
      then((response) => {
          this.showNewSite();
      }).catch((error) => {
          this.checking = false;
          this.sweetfire(error.response.data.message);
      }).finally(() => {
          this.checking = false;
      });

    },

    showNewSite() {
      this.$refs.NewSite.clearSite();
      this.$bvModal.show('bv-modal-new-site'); 
      },
    showTrackingCode(site) { 
      this.selectedSite = site;
      this.$bvModal.show('bv-modal-tracking-code'); 
      },
    showDeleteSite(site) { 
      this.$refs.DeleteSite.clearContent();
      this.selectedSite = site;
      this.$bvModal.show('bv-modal-delete-site'); 
      },

    getWebsites(showLoading = false) {

      this.loadingFilter = showLoading;

      axios.post(`/websites/list`, {
        filter: this.filter,
      }).
      then((response) => {
        this.sites = response.data.sites;
        this.rangeText = response.data.rangeText
      }).catch((error) => {
        this.sweetfire(error.response.data.message);
      }).finally(() => {
        this.loading = false;
        this.loadingFilter = false;
      });

    },

    

  },
};
</script>